import { AddressType } from '@/app/shared/enums';
import { Model } from '@/app/shared/models/model';

export class AddressInsuranceModel extends Model {
  public Type!: AddressType;
  public Street!: string;
  public Number!: string;
  public Complement!: string;
  public Neighborhood!: string;
  public City!: string;
  public PostalCode!: string;
  public SubdivisionCode!: string;
  public CountryCode!: string;

  constructor() {
    super();
    this.Type = AddressType.Residential;
    this.CountryCode = '55';
    this.PostalCode = '';
  }
}
